import linkedin from '../assets/images/linkedin.svg'
import github from '../assets/images/github.svg'
import './header.scss'
import '../Utility/display.scss'
import '../Utility/positions.scss'
import '../Utility/size.scss'
import '../Utility/screenreader.scss'
import { useStateContext } from '../context'
import { createEffect, createSignal, onMount } from 'solid-js'
import { clickOutside } from '../directives'

export default function Header() {
    const state = useStateContext();
    let [hamburgerLineClass, setHamburgerLineClass] = createSignal("hamburger-line");
    let [hamburgerClass, setHamburgerClass] = createSignal("hamburger-line");
    createEffect(() => {
        if (state.isNavOpen()) {
            setHamburgerLineClass("hamburger-line-close");
            setHamburgerClass("hamburger hamburger-close");
        } else {
            setHamburgerLineClass("hamburger-line");
            setHamburgerClass("hamburger");
        }
    });
    let links: HTMLAnchorElement[] = [];
    let animateLink = (e: Event) => {
        const target = e.target as HTMLLIElement;
        target.classList.add("animateLink");
    }
    onMount(() => {
        for (const link of links) {
            link.addEventListener("animationend", () => {
                link.classList.remove("animateLink");
            }, { once: false });
        }
    });
    return (
        <div class="primary-header flex full-width">
            <button class="mobile-nav-toggle" aria-controls="primary-navigation" aria-expanded={state.isNavOpen() || !state.isSmallViewport()} onClick={state.toggleIsNavOpen}>
                <svg
                    class={hamburgerClass()}
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    viewBox="-10 -10 120 120"
                    // stroke="var(--button-color)"
                    // fill="none"
                >
                    <path class={hamburgerLineClass()} stroke-width="10" stroke-linecap="round" stroke-linejoin="round" d="m 20 40 h 60 a 1 1 0 0 1 0 20 h -60 a 1 1 0 0 1 0 -40 h 30 v 70"></path>
                </svg>
                {/* <span class="sr-only">Menu</span> */}
            </button>
            <nav>
                <ul data-visible={state.isNavOpen() || !state.isSmallViewport()} id="primary-navigation" class="primary-navigation flex">
                    <li>
                        <a ref={links[0]} onClick={(e: Event) => { state.toggleChatbox(); animateLink(e); }}>Ai</a>
                    </li>
                    <li>
                        <a ref={links[1]} onClick={(e: Event) => { state.toggleGuestbook(); animateLink(e); }}>Guestbook</a>
                    </li>
                    <li>
                        <a ref={links[2]} onClick={animateLink} href="https://www.linkedin.com/in/joshhussey/" target="_blank">
                           <img src={linkedin} />LinkedIn</a>
                    </li>
                    <li>
                        <a ref={links[3]} onClick={animateLink} href="https://www.github.com/joshahussey" target="_blank">
                            <img src={github} />GitHub</a>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

// <div class="header">
//     <div class="panel">
//         <button class="panel-button" onClick={toggleGuestbook}>{isGuestbookOpen() ? "Close Guestbook!" : "Open Guestbook!"}</button>
//     </div>
//     <div class="socials">
//         <a href="https://www.linkedin.com/in/joshhussey/" target="_blank">
//             <img src={linkedin} alt="LinkedIn" />
//             <span>LinkedIn</span>
//         </a>
//         <a href="https://www.github.com/joshahussey" target="_blank">
//             <img src={github} alt="GitHub" />
//             <span>GitHub</span>
//         </a>
//     </div>
        // </div>
